<template>
  <v-row>
    <v-col cols="12" lg="12">
      <SumarryReports isActive="activated"></SumarryReports>
    </v-col>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Activated List
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <v-btn color="primary" class="ml-auto">
                  <download-csv :data="exportData" :name="`${fileName}.csv`">
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </download-csv>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.brandId`]="{ item }">
            {{ filterBrands(item.brandId)[0].name }}
          </template>

          <template v-slot:[`item.modelId`]="{ item }">
            {{ filterModels(item.modelId)[0].name }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <!-- <a @click="viewDrawDetail(item)">{{ item.name }}</a> -->
            <v-btn small color="primary" dark @click="editDrawDetail(item)">
              Check Status</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import SumarryReports from "./components/dashboard_components/SumarryReports.vue";
export default {
  name: "ActivatedList",
  components: {
    SumarryReports,
  },
  data() {
    return {
      exportData: [],
      fileName: "",

      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [
          {
            text: "SN",
            sortable: false,
            value: "serialNumber",
          },
          { text: "Type", value: "type" },
          { text: "Model", value: "model" },
          {
            text: "Date/Time Received from WH",
            value: "createdDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
          { text: "Released by", value: "releasedBy" },
          { text: "Received by", value: "receivedBy" },
          {
            text: "Activation Date/Time",
            value: "activationdate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
        ],
        data: [],
      },

      brands: [],
      models: [],
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getSerialAdded() {
      this.table.loading = true;
      await this.$api
        .get("/dashboard/inventory?status=ACTIVATED")
        .then((response) => {
          const newArr = response.data.data.devices;
          this.table.data = newArr;

          let exportData = newArr.map((item) => {
            return {
              SN: item.serialNumber,
              Type: item.type,
              Model: item.model,
              "Date/Time Received from WH": moment(item.createdDate).format(
                "MMM DD, YYYY h:mm:ss A"
              ),
              "Released by": item.releasedBy,
              "Received by": item.receivedBy,
              "Activation Date/Time": moment(item.activationdate).format(
                "MMM DD, YYYY h:mm:ss A"
              ),
            };
          });
          this.fileName = "activated_list";
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async getBrands() {
      // this.table.loading = true;
      await this.$api
        .get("/inventory/brands")
        .then((response) => {
          const newArr = response.data.data;
          this.brands = newArr.brands;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getModels() {
      // this.table.loading = true;
      await this.$api
        .get("/inventory/models")
        .then((response) => {
          const newArr = response.data.data;
          this.models = newArr.models;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    filterBrands(id) {
      const brand = this.brands.filter((brand) => brand._id == id);
      return brand;
      // console.log(brand);
    },

    filterModels(id) {
      const models = this.models.filter((model) => model._id == id);
      return models;
      // console.log(brand);
    },
  },
  created() {
    this.getBrands();
    this.getModels();
    this.getSerialAdded();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
